/**
 * @file 剧本常量
 * @author zhanghaohan
 */

// 数字人剧本列表关联直播间状态
export const SCRIPT_LIVE_STATUS = {
    RESERVE: -1, // 预约
    LIVE: 0, // 直播中
    END: 1, // 关播
    CANCEL: 2, // 取消
    OCCUPY: 3, // 被占用
    DEFAULT: -2 // 未关联直播间
};

// 此处状态对应scriptList中的status字段,其中3这个状态是人工审核中，后端专门加的
export const SCRIPT_AUDIT_STATUS = {
    AUDIT_WAIT: 3, // 待审核,人工审核
    AUDIT_REJECT: 4, // 拒绝，人工审核
    AUTO_AUDIT_WAIT: 7, // 机审中
    AUTO_AUDIT_REJECT: 8// 机审失败
};

// 用户首次进入剧本
export const SCRIPT_EDITOR_FIRST_ENTER = 'huibo_digital_anchor_editor_first_enter';

// 推流状态：0-未推流 3-推流中 1-正在推流 -1-停止推流 -2-推流失败
export const SCRIPT_LIVE_PUSH_STATUS = {
    COMPOSITING_TIMEOUT: {
    // 画面合成超时
        value: 11,
        tip: '画面合成超时,请重试',
        class: 'btn-tooltip-error'
    },
    COMPOSITING_CANCEL: {
    // 画面合成取消
        value: 10,
        tip: '',
        class: 'btn-tooltip-blank'
    },
    PUSH_ING: {
    // 直播中
        value: 3,
        tip: '直播中',
        class: 'btn-tooltip-success'
    },
    PUSH_CONNECT: {
    // 连接中
        value: 2,
        tip: '连接中',
        class: 'btn-tooltip-pending'
    },
    PUSH_INIT: {
    // 推流初始化
        value: 12,
        tip: '画面已合成,待推流',
        class: 'btn-tooltip-pending'
    },
    COMPOSITING_DONE: {
    // 画面已合成
        value: 1,
        tip: '画面已合成,待推流',
        class: 'btn-tooltip-pending'
    },
    COMPOSITING_ING: {
    // 画面合成中
        value: 0,
        tip: '画面合成中',
        class: 'btn-tooltip-pending'
    },
    INIT: {
    // 初始化
        value: -1,
        tip: '',
        class: 'btn-tooltip-blank'
    },
    COMPOSITING_FAIL: {
    // 画面合成失败
        value: -2,
        tip: '画面合成失败,请重试',
        class: 'btn-tooltip-error'
    },
    PUSH_FAIL: {
    // 推流失败
        value: -3,
        tip: '连接失败,请重试',
        class: 'btn-tooltip-error'
    }
};

export const PUSH_TYPE_OPTIONS = [
    // {
    //     value: 1,
    //     text: '推流码开播'
    // },
    {
        value: 2,
        text: '拉流助手开播'
    }
];

export const PLATFORM_OPTIONS = [
    {
        value: 1,
        label: '快手'
    },
    {
        value: 2,
        label: '淘宝'
    }
];

export const CONFIG_TYPE_OPTIONS = [
    {
        value: 1,
        text: '手动配置'
    }
];

export const LIVE_PUSH_CONFIGS = [
    {
        property: 'pushType',
        title: '开播方式',
        options: PUSH_TYPE_OPTIONS,
        component: 'radio'
    },
    {
        property: 'configType',
        title: '推流码配置',
        options: CONFIG_TYPE_OPTIONS,
        component: 'radio',
        pushType: 1
    },
    {
        property: 'pushServer',
        title: '服务器',
        required: true,
        component: 'input',
        pushType: 1
    },
    {property: 'pushCode', title: '推流码', component: 'input', pushType: 1},
    {property: 'platform', title: '', component: 'select'},
    {property: 'thirdUrl', title: '外部直播间链接', component: 'input'}
];

// 保存类型
export const SAVETYPES = {
    SAVE: 1, // 保存
    SAVEANDSTART: 2 // 保存并推流
};

export const QUERY_PROGRESS_TYPE = {
    ANCHOR: 'smart_anchor_list',
    LIVE: 'live_room_info',
    VIDEO: 'video_info',
    EXTERNAL: 'external_room_info',
    AI_QA: 'ai_qa_progress',
    AI_SCRIPT: 'ai_script_progress'
};

// 贴片来源
export const PASTER_SUBTYPE = {
    PRIVATE: 'private', // 个人库
    PUBLIC: 'public', // 公共库
    TEMPLATE: 'template', // 模版
    GROUP: 'group' // 贴片组
};

export const CARD_PAGE =  [
    {name: '无跳转', value: '0', menu: ''},
    {name: '问答页面', value: '1', menu: 'faq'},
    {name: '剧本编辑页', value: '2', menu: 'editor'}
];
// 分镜类型
export const PAGE_TYPE = {
    VIDEO: 2, // 切镜
    DEFAULT: 1// 普通分镜
};
